import Vue from 'vue'
import { MutationTree } from 'vuex'

import { Item } from '@/models'

import { makeRelationalObject } from '../../models'
import { ItemGroupItems, MenuState } from '../state'

export const ADD_ITEM = 'ADD_ITEM'
export const ADD_ITEM_GROUP_ITEMS = 'ADD_ITEM_GROUP_ITEMS'
export const CLEAR_ITEM_GROUPS_ITEMS = 'CLEAR_ITEM_GROUPS_ITEMS'
export const INCREMENT_ITEM_GROUP_ITEMS_QUERY_INDEX = 'INCREMENT_ITEM_GROUP_ITEMS_QUERY_INDEX'
export const LOADED_ALL_ITEM_GROUP_ITEMS = 'LOADED_ALL_ITEM_GROUP_ITEMS'
export const REMOVE_ITEM_GROUP_ITEMS = 'REMOVE_ITEM_GROUP_ITEMS'
export const RESET_ITEM_GROUP_ITEMS_QUERY_INDEX = 'RESET_ITEM_GROUP_ITEMS_QUERY_INDEX'
export const RESET_LOADED_ALL_ITEM_GROUP_ITEMS = 'RESET_LOADED_ALL_ITEM_GROUP_ITEMS'
export const UPDATE_ITEM_GROUP_ITEMS = 'UPDATE_ITEM_GROUP_ITEMS'
export const UPDATE_ITEM_GROUP_ITEMS_TOTAL = 'UPDATE_ITEM_GROUP_ITEMS_TOTAL'
export const UPDATE_ITEMS = 'UPDATE_ITEMS'

const mutations: MutationTree<MenuState> = {
  [ADD_ITEM] (state, item: Item) {
    state.items.elements.push(item)
  },

  [ADD_ITEM_GROUP_ITEMS] (state, itemGroupId: number) {
    const itemGroupItems: ItemGroupItems = {
      ...makeRelationalObject(),
      query: {}
    }

    Vue.set(state.itemGroups.items, itemGroupId, itemGroupItems)
  },

  [CLEAR_ITEM_GROUPS_ITEMS] (state) {
    state.itemGroups.items = {}
  },

  [INCREMENT_ITEM_GROUP_ITEMS_QUERY_INDEX] (
    state,
    { itemGroupId, offset }: { itemGroupId: number; offset: number }
  ) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.query.index = (itemGroupItems.query.index ?? 0) + offset
  },

  [LOADED_ALL_ITEM_GROUP_ITEMS] (state, itemGroupId: number) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.didLoadAll = true
  },

  [REMOVE_ITEM_GROUP_ITEMS] (state, itemGroupId: number) {
    Vue.delete(state.itemGroups.items, itemGroupId)
  },

  [RESET_ITEM_GROUP_ITEMS_QUERY_INDEX] (state, itemGroupId: number) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.query.index = 0
  },

  [RESET_LOADED_ALL_ITEM_GROUP_ITEMS] (state, itemGroupId: number) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.didLoadAll = false
  },

  [UPDATE_ITEM_GROUP_ITEMS] (
    state,
    { itemGroupId, items }: { itemGroupId: number; items: number[] }
  ) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.ids = new Set(items)
  },

  [UPDATE_ITEM_GROUP_ITEMS_TOTAL] (
    state,
    { itemGroupId, total }: { itemGroupId: number; total: number }
  ) {
    const itemGroupItems = state.itemGroups.items[itemGroupId]

    if (itemGroupItems === undefined) {
      throw new Error(`Items relation for ItemGroup "${itemGroupId}" was not found`)
    }

    itemGroupItems.total = total
  },

  [UPDATE_ITEMS] (state, items: Item[]) {
    state.items.elements = items
  }
}

export default mutations
